import type { PreviewPublishDiff, PreviewPublishSnapshot } from '../../services/games';

function isDeleted(item: PreviewPublishSnapshot): boolean {
    return item.deletedAt != null;
}

function isNewer(draftUpdatedAt: string, liveUpdatedAt: string): boolean {
    return Date.parse(draftUpdatedAt) > Date.parse(liveUpdatedAt);
}

function hasUnpublishedGameChanges(
    drafts: PreviewPublishSnapshot[],
    lives: PreviewPublishSnapshot[]
): boolean {
    const liveById = new Map(lives.map((item) => [item.id, item]));
    const draftById = new Map(drafts.map((item) => [item.id, item]));

    for (const draft of drafts) {
        const live = liveById.get(draft.id);

        if (isDeleted(draft)) {
            if (live && !isDeleted(live)) {
                return true;
            }

            continue;
        }

        if (!live || isDeleted(live)) {
            return true;
        }

        if (isNewer(draft.updatedAt, live.updatedAt)) {
            return true;
        }
    }

    for (const live of lives) {
        if (isDeleted(live)) {
            continue;
        }

        const draft = draftById.get(live.id);

        if (!draft || isDeleted(draft)) {
            return true;
        }
    }

    return false;
}

function hasUnpublishedLanguageChanges(
    drafts: PreviewPublishSnapshot[],
    lives: PreviewPublishSnapshot[]
): boolean {
    const liveById = new Map(lives.map((item) => [item.id, item]));
    const draftById = new Map(drafts.map((item) => [item.id, item]));

    for (const draft of drafts) {
        const live = liveById.get(draft.id);

        if (!live || isNewer(draft.updatedAt, live.updatedAt)) {
            return true;
        }
    }

    for (const live of lives) {
        if (!draftById.has(live.id)) {
            return true;
        }
    }

    return false;
}

export function hasUnpublishedChanges(diff: PreviewPublishDiff): boolean {
    return (
        hasUnpublishedGameChanges(diff.draftGameConfigurations, diff.gameConfigurations) ||
        hasUnpublishedLanguageChanges(diff.draftGameLanguages, diff.gameLanguages)
    );
}
